import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { WalletLinkConnector } from "@web3-react/walletlink-connector";
import { TrezorConnector } from "@web3-react/trezor-connector";
import { LedgerConnector } from "@web3-react/ledger-connector";

const POLLING_INTERVAL = 8000;
export const Injected = new InjectedConnector({
  supportedChainIds: [1, 3, 4, 5, 42, 56],
});

export const Walletconnect = new WalletConnectConnector({
  rpcUrl: `https://mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`,
  bridge: "https://bridge.walletconnect.org",
  qrcode: true,
});

export const Walletlink = new WalletLinkConnector({
  url: `https://mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`,
  appName: "liontravelers",
});

export const Ledger = new LedgerConnector({
  chainId: 1,
  url: `https://mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`,
  pollingInterval: POLLING_INTERVAL,
});

export const Trezor = new TrezorConnector({
  chainId: 1,
  url: `https://mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`,
  pollingInterval: POLLING_INTERVAL,
  manifestEmail: "noahwz@gmail.com",
  manifestAppUrl: "https://codesandbox.io/s/6v5nrq2nqw",
});

const connectors = {
  Injected: Injected,
  WalletConnect: Walletconnect,
  CoinbaseWallet: Walletlink,
  Trezor: Trezor,
  Ledger: Ledger,
};

export default connectors;